import { getContext } from '@fiverr-private/fiverr_context';
import { stats } from '@fiverr-private/obs';
import { STATS_PREFIX } from './constants';

export const isDev = () => process.env.NODE_ENV === 'development';

export const isLoggedIn = () => {
    if (isDev()) {
        return true;
    }

    const { userId } = getContext();

    return !!userId;
};

export const count = (key) => stats.count(STATS_PREFIX, key);

export const getUserType = () => {
    if (window.dataLayer && window.dataLayer.length > 0 && window.dataLayer[0]) {
        return window.dataLayer[0].user_type || null;
    }
    return null;
};
